import * as React from "react"
import styles from "./DsNavbarBackoffice.module.scss"

import DsLogoBlancoElGlobo from "@components/others/DsLogoBlancoElGlobo/DsLogoBlancoElGlobo.tsx"
import useResponsiveToolCtx from "@contexts/hooks/useResponsiveToolCtx.tsx"
import DvUserAvatarBackoffice from "@components/dataDisplay/DvUserAvatarBackoffice/DvUserAvatarBackoffice.tsx"
import DsProfileDropDownBackoffice from "@components/navigation/DsProfileDropDownBackoffice/DsProfileDropDownBackoffice.tsx"

interface IProps {
	className?: string
}

const DsNavbarBackoffice: React.FC<IProps> = (props) => {
	const { isMobile } = useResponsiveToolCtx()

	return (
		<header
			className={`${styles.ds_navbar_backoffice} ${props.className || ""} `}
		>
			<DsLogoBlancoElGlobo
				type="horizontal"
				height={isMobile ? 34 : undefined}
				width={isMobile ? 138 : undefined}
			/>

			<div className={styles.action_container}>
				<DsProfileDropDownBackoffice>
					<DvUserAvatarBackoffice className={styles.user_avatar} />
				</DsProfileDropDownBackoffice>
			</div>
		</header>
	)
}

export default React.memo(DsNavbarBackoffice)
